import { DropdownItem, DropdownItemType, DropdownSelectableItem, ScreenSize, Selectable } from '@akmf/ng-shared';
import { Component, ChangeDetectionStrategy, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppConfigService } from 'src/app/core/services/app-config.service';

@Component({
  selector: 'app-simple-layout',
  templateUrl: './simple-layout.component.html',
  styleUrls: ['./simple-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SimpleLayoutComponent implements OnDestroy {
  languageList: DropdownItem[];
  ScreenSize = ScreenSize;
  private unsubscribe$ = new Subject();

  onLangClick = (item: DropdownItem) => {
    const obs = this.translate.use(item.name.toLowerCase()).pipe(takeUntil(this.unsubscribe$));

    obs.subscribe(() => {
      this.languageList.forEach((listItem) => {
        if (listItem.type !== DropdownItemType.button) {
          (listItem as Selectable).selected = false;
        }
      });
      (item as Selectable).selected = true;
    });

    return obs;
  };

  constructor(private translate: TranslateService, public appConfigService: AppConfigService) {
    this.languageList = this.translate.getLangs().map((lang, index) => {
      const res: DropdownSelectableItem = {
        id: index,
        type: DropdownItemType.selectable,
        name: lang.toUpperCase(),
        disabled: false,
        selected: this.translate.currentLang === lang.toLowerCase(),
        clickFn: this.onLangClick,
      };
      return res;
    });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
